'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';

type Theme = 'dark' | 'light';

interface ThemeContextValue {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextValue>({
  theme: 'dark',
  toggleTheme: () => {},
});

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useState<Theme>('dark');

  useEffect(() => {
    const stored = localStorage.getItem('fca-theme') as Theme | null;
    const resolved = stored === 'light' ? 'light' : 'dark';
    setTheme(resolved);
    applyTheme(resolved);
  }, []);

  const applyTheme = (t: Theme) => {
    const root = document.documentElement;
    if (t === 'light') {
      root.classList.add('light');
      root.classList.remove('dark');
    } else {
      root.classList.add('dark');
      root.classList.remove('light');
    }
  };

  const toggleTheme = () => {
    const next: Theme = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    localStorage.setItem('fca-theme', next);
    applyTheme(next);
  };

  return (
    <ThemeContext.Provider data-component-id="src/lib/ThemeContext.tsx:46:4" data-component-path="src/lib/ThemeContext.tsx" data-component-line="46" data-component-end-line="48" data-component-file="ThemeContext.tsx" data-component-name="ThemeContext.Provider" data-component-content="%7B%22elementName%22%3A%22ThemeContext.Provider%22%7D" value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
